//import { authStore } from 'stores';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const newAccount = async (userId) => {
    //const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;

    window.location = `${API_URL}/stripe/new?userId=${userId}`;
};
